<template>
  <v-navigation-drawer
    left
    fixed
    temporary
    app
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list dense nav>
      <v-list-item three-line>
        <v-list-item-avatar tile color="" size="60">
          <v-img :src="require('@/assets/logo-argecam.png')"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <div class="font-weight-light text-h6">
              ARGECAM
              <span class="accent--text font-weight-bold">SRL</span>
            </div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mb-5"></v-divider>
      <v-list-item link :to="sec.to" v-for="sec in items" :key="sec.name">
        <v-list-item-content>
          <v-list-item-title class="text-uppercase" v-text="sec.name" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "AppBarDrawer",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "App"
    },
    subtitle: {
      type: String
    }
  }
};
</script>

<style></style>
